// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommonApi } from '@digitalasset/utility-operator-api-ts-client';
import React, { useContext } from 'react';

export const UtilityCommonApiContext = React.createContext<CommonApi | undefined>(undefined);

export const useUtilityCommonApiClient: () => CommonApi = () => {
  const client = useContext<CommonApi | undefined>(UtilityCommonApiContext);
  if (!client) {
    throw new Error('Utility common client not initialized');
  }
  return client;
};
